<template>
    <div class="w-full max-w-120 rounded shadow-xl | transition duration-300">
        <form class="p-6 rounded bg-white space-y-6" @submit.prevent="sendPasswordResetEmail">
            <p class="text-center" v-text="$t('auth.forgotPassword.instructions')" />

            <div class="space-y-3">
                <nio-input
                    :placeholder="$t('auth.forgotPassword.email')"
                    required
                    type="text"
                    v-model="email"
                />
            </div>

            <nio-button
                class="w-full"
                color="blue"
                :disabled="!valid"
                type="submit"
            >
                {{ $t('global.general.send') }}
            </nio-button>

            <nio-alert type="error" v-if="error">
                {{ this.$t(`auth.forgotPassword.${error}`) }}
            </nio-alert>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                error: '',
                loading: false,
            };
        },

        computed: {
            valid() {
                return !!this.email;
            },
        },

        watch: {
            email() {
                this.error = '';
            },
        },

        methods: {
            async sendPasswordResetEmail() {
                if (!this.valid) {
                    return;
                }

                this.loading = true;

                try {
                    await this.$axios.post('password/email', {
                        email: this.email,
                        user_type: 'user',
                    });

                    this.loading = false;

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('auth.forgotPassword.emailSentText'),
                    });

                    this.$router.push({ name: 'auth.login' });
                } catch (error) {
                    if (error.response.status == 400) {
                        this.error = 'userNotFound';
                    } else if (error.response.status == 422) {
                        this.error = 'invalidEmail';
                    } else {
                        this.error = 'unknownError';
                    }

                    this.loading = false;
                }
            },
        },
    };
</script>
